﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.DailyPlanConfirmationService
 * @description
 * # DailyPlanConfirmationService
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('DailyPlanConfirmationService', ['ConfirmationService', function (ConfirmationService) {

      function moveStaffFromRoomDetailsToResourcePool(message, data) {
          return ConfirmationService.YesNoConfirmation(message, 'ng1/src/dailyPlan/views/popups/moveStaffToResourcePoolAlert.html', data);
      }

      function moveFromResourcePool(message, staffSkills) {

          if (staffSkills) {
              var data = {
                  skills: staffSkills
              };

              return ConfirmationService.YesNoConfirmation(message, 'ng1/src/dailyPlan/views/popups/dragFromResourcePoolStaffSkillsAlert.html', data);
          }

          return new ConfirmationService.YesNoConfirmation(message, 'ng1/src/dailyPlan/views/popups/dragFromResourcePoolAlert.html');
      }

      function moveStaffFromResourcePoolToRoomActivityRow(message) {
          return new ConfirmationService.YesNoConfirmation(message, 'ng1/src/dailyPlan/views/popups/moveStaffFromResourcePoolToActivityRow.html');
      }

      function borrowAction(message) {
          return new ConfirmationService.YesNoConfirmation(message, 'ng1/src/dailyPlan/views/popups/borrowActionAlert.html  ');
      }

      var service = {};

      angular.extend(service, ConfirmationService);
      service.MoveStaffFromRoomDetailsToResourcePool = moveStaffFromRoomDetailsToResourcePool;
      service.MoveFromResourcePool = moveFromResourcePool;
      service.MoveStaffFromResourcePoolToRoomActivityRow = moveStaffFromResourcePoolToRoomActivityRow;
      service.BorrowAction = borrowAction;

      return service;

  }]);